import { useQuery } from '@tanstack/react-query';
import { fetchDocumentTemplates } from '../services/documentTemplates';
import type { AssignableDocumentType, DocumentTemplateListParams } from '../types/documentTemplates.types';
import { documentTemplateKeys } from './documentTemplateKeys';

export const ASSIGNABLE_TEMPLATES_PAGE_SIZE = 100;

export function useAssignableTemplatesQuery(documentType: AssignableDocumentType | null, dealerId: string | null) {
  const params: DocumentTemplateListParams = {
    documentType: documentType ?? undefined,
    status: 'published',
    ...(dealerId ? { availableToDealerId: dealerId } : { owner: 'platform' }),
    sort: 'name',
    perPage: ASSIGNABLE_TEMPLATES_PAGE_SIZE,
  };

  return useQuery({
    queryKey: documentTemplateKeys.list(params),
    queryFn: () => fetchDocumentTemplates(params),
    enabled: documentType !== null,
  });
}
